export const PLAN_COPY = [
  {
    key: "explorer",
    eyebrow: "14-Day Free Trial",
    plan: "TWIN Explorer",
    headline: "Before You Review, Screen First.",
    desc: "Screen out unsuitable tenders before detailed review.",
    feats: [
      "Tender register & upload",
      "TESM – 10-parameter early screening",
      "Screening scores & red flags",
      "Tender tracking & dashboard",
      "Essential tendering templates",
      "1 user · Up to 25 active tenders",
    ],
    cta: "Start 14-Day Free Trial",
    closing: "Experience smarter tender screening with TWIN Explorer.",
  },
  {
    key: "growth",
    eyebrow: "Structured Bid/No-Bid Decisions",
    plan: "TWIN Growth",
    headline: "Before You Bid, Know If You Should.",
    desc: "Make informed Bid/No-Bid decisions before committing tendering resources.",
    feats: [
      "Everything in TWIN Explorer",
      "BNBD – Structured Bid/No-Bid Diagnostic",
      "Bid suitability scores & red flags",
      "Documented Bid/No-Bid recommendations",
      "Tender governance dashboard",
      "5 users · Up to 50 active tenders",
    ],
    cta: "Get Started",
    closing: "Bid on the Right Tenders. Improve Your Chances of Winning.",
  },
  {
    key: "professional",
    eyebrow: "Complete Tender Governance",
    plan: "TWIN Professional",
    headline: "Before You Commit, Govern Better.",
    desc: "Manage contractual exposure, pricing readiness and performance.",
    feats: [
      "Everything in TWIN Growth",
      "PCEI – Pre-Contract Exposure Index",
      "PCAB – Pricing Competency & Accuracy",
      "TAPI – Tender Analysis & Performance Indicator",
      "Tender Governance Dashboard",
      "10 users · Up to 100 active tenders",
    ],
    cta: "Get Started",
    closing: "Protect Margins. Improve Winning.",
    featured: true,
  },
];
